import React, { useEffect, useRef, useState } from "react";
import { ImageLink } from "../../../utils/constants";
import axiosInstance from "../../../axiosInterceptor";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import Loader from "../../../Components/Loader";

export default function Invoice() {
    const { id } = useParams();
  const invoiceRef = useRef();
  const [data, setData] = useState({});
    const [webSetting,setwebSetting]=useState({})
    const [loading,setLoading]=useState(true)

const fetchInvocedata = async (id) => {
  try {
    setLoading(true);

    const [orderRes, settingRes] = await Promise.all([
      axiosInstance.get(`/customer/order/details/${id}`),
      axiosInstance.get(`/websetting`),
    ]);

    if (orderRes.status === 200) {
      setData(orderRes.data?.data);
    }
    if (settingRes.status === 200) {
      setwebSetting(settingRes.data?.data);
    }
  } catch (error) {
    toast.error(error.response?.data?.message || "Something went wrong");
  } finally {
    setLoading(false);
  }
};

useEffect(() => {
  if (id) fetchInvocedata(id);
}, [id]);

const [downloading, setDownloading] = useState(false);


const downloadPDF = async () => {
  try {
    setDownloading(true); 
    // const element = invoiceRef.current;

    // const canvas = await html2canvas(element, {
    //   scale: 2,
    //   useCORS: true,
    //   allowTaint: true,
    // });

    // const imgData = canvas.toDataURL("image/png");
  } catch (err) {
    toast.error("Failed to download invoice");
  } finally {
    setDownloading(false); 
  }
};


 if (loading) {
    return <Loader />;
  }
  return (
    <div className="content-wrapper mt-5 mb-5">
    <div className="d-flex justify-content-end mt-3 mb-3">
  <button
    onClick={downloadPDF}
    className="btn btn-primary d-flex align-items-center justify-content-center"
    disabled={downloading}
  >
    {downloading ? (
      <>
        Generating...
        <span
          className="spinner-border spinner-border-sm ms-2"
          role="status"
          aria-hidden="true"
        ></span>
      </>
    ) : (
      "Download Invoice"
    )}
  </button>
</div>


        
      <div ref={invoiceRef} className="border p-4 bg-white rounded shadow-sm">
        <div className="d-flex justify-content-between align-items-start border-bottom pb-3 mb-3">
          <div>
            {webSetting?.headerLogo && (
              <img
                src={ImageLink(webSetting.headerLogo)}
                alt="Company Logo"
                height="50"
                className="mb-2"
                 crossOrigin="anonymous"
              />
            )}
            <p className="mb-1">{webSetting?.address}</p>
            <p className="mb-1">Email: {webSetting?.email}</p>
            <p className="mb-0">
              Phone: {webSetting?.domesticNumber || webSetting?.interNationalNumber}
            </p>
          </div>
          <div className="text-end">
            <h3 className="fw-bold text-dark">INVOICE</h3>
            <p className="mb-1">Order ID: {data.orderId}</p>
            <p className="mb-1">Date: {data.orderDate}</p>
            <p className="mb-0">Status: {data.status}</p>
          </div>
        </div>

        <div className="row mb-4">
          <div className="col-md-6">
            <h5>Billing Address:</h5>
            <p className="mb-1">{data.billingAddress?.fullName}</p>
            <p className="mb-1">{data.billingAddress?.address1}</p>
            <p className="mb-1">
              {data.billingAddress?.city}, {data.billingAddress?.state} -{" "}
              {data.billingAddress?.zipCode}
            </p>
            <p className="mb-1">{data.billingAddress?.country}</p>
            <p className="mb-1">Email: {data.billingAddress?.email}</p>
            <p className="mb-0">Phone: {data.billingAddress?.mobile}</p>
          </div>
          <div className="col-md-6">
            <h5>Shipping Address:</h5>
            <p className="mb-1">{data.shippingAddress?.fullName}</p>
            <p className="mb-1">{data.shippingAddress?.address1}</p>
            <p className="mb-1">
              {data.shippingAddress?.city}, {data.shippingAddress?.state} -{" "}
              {data.shippingAddress?.zipCode}
            </p>
            <p className="mb-0">{data.shippingAddress?.country}</p>
          </div>
        </div>

        <div className="table-responsive mb-4">
          <table className="table table-bordered align-middle">
            <thead className="table-light">
              <tr>
                <th>Item</th>
                <th className="text-center">Qty</th>
                <th className="text-end">Price</th>
                <th className="text-end">Subtotal</th>
              </tr>
            </thead>
            <tbody>
              {data.orderItems?.map((item) => (
                <tr key={item.id}>
                  <td>{item.name}</td>
                  <td className="text-center">{item.quantity}</td>
                  <td className="text-end">
                    {item.productsnapshots.price || 0}
                  </td>
                  <td className="text-end">
                   {item.productsnapshots.subtotal || 0}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="row justify-content-end">
          <div className="col-md-6">
            <table className="table table-borderless">
              <tbody>
                <tr>
                  <td>Subtotal:</td>
                  <td className="text-end">
                    {data?.subtotal || 0}
                  </td>
                </tr>
                <tr>
                  <td>Shipping:</td>
                  <td className="text-end">
                   {data?.shippingcharge || 0}
                  </td>
                </tr>
                <tr>
                  <td>Discount:</td>
                  <td className="text-end">
                    {data?.discount || 0}
                  </td>
                </tr>
                <tr>
                  <td>Tax:</td>
                  <td className="text-end">
                   {data?.tax || 0}
                  </td>
                </tr>
                <tr className="table-light fw-bold">
                  <td>Total:</td>
                  <td className="text-end">
                    {data?.totalAmount || 0}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className="text-center border-top pt-3 mt-4">
          {webSetting?.headerLogo && (
            <img
              src={ImageLink(webSetting.headerLogo)}
              alt="Footer Logo"
              height="40"
              className="mb-2"
               crossOrigin="anonymous"
            />
          )}
          <p className="small text-muted mb-0">{webSetting?.copyRightText}</p>
        </div>
      </div>

      
    </div>
  );
}
